var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoTableNotUserBSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 1.44,
  d: "M13.24 14.32c0-.597.483-1.08 1.08-1.08h12.77c.596 0 1.08.483 1.08 1.08v30.96a1.08 1.08 0 0 1-1.08 1.08H14.32a1.08 1.08 0 0 1-1.08-1.08V14.32ZM31.429 14.32c0-.597.484-1.08 1.08-1.08h12.77c.597 0 1.08.483 1.08 1.08v12.77a1.08 1.08 0 0 1-1.08 1.08H32.51a1.08 1.08 0 0 1-1.08-1.08V14.32ZM31.429 38.894a7.465 7.465 0 1 1 14.93 0 7.465 7.465 0 0 1-14.93 0Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.84 2.44h7.2l.541 5.956a1.8 1.8 0 0 1-1.792 1.963H18.09a1.8 1.8 0 0 1-1.793-1.963l.542-5.957Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m16.12 3.88.16-.321a2.025 2.025 0 0 1 1.811-1.12h4.697c.767 0 1.468.434 1.811 1.12l.16.32"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.84 57.16h7.2l.541-5.957a1.8 1.8 0 0 0-1.792-1.963H18.09a1.8 1.8 0 0 0-1.793 1.963l.542 5.957Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m16.12 55.72.16.32a2.025 2.025 0 0 0 1.811 1.12h4.697c.767 0 1.468-.433 1.811-1.12l.16-.32"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.16 24.04v-7.2l5.957-.542a1.8 1.8 0 0 1 1.963 1.793v4.698a1.8 1.8 0 0 1-1.963 1.792L3.16 24.04Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m4.6 24.76-.32-.16a2.025 2.025 0 0 1-1.12-1.812v-4.697c0-.767.434-1.468 1.12-1.81l.32-.161"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M2.44 24.04v-7.2l5.957-.542a1.8 1.8 0 0 1 1.963 1.793v4.698a1.8 1.8 0 0 1-1.963 1.792L2.44 24.04Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m3.88 24.76-.32-.16a2.025 2.025 0 0 1-1.12-1.812v-4.697c0-.767.433-1.468 1.12-1.81l.32-.161"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M57.16 24.04v-7.2l-5.957-.542a1.8 1.8 0 0 0-1.963 1.793v4.698a1.8 1.8 0 0 0 1.963 1.792l5.957-.541Z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m55.72 24.76.32-.16a2.025 2.025 0 0 0 1.12-1.812v-4.697c0-.767-.434-1.468-1.12-1.81l-.32-.161"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.16 42.76v-7.2l5.957-.541a1.8 1.8 0 0 1 1.963 1.793v4.697a1.8 1.8 0 0 1-1.963 1.793l-5.957-.541Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m4.6 43.48-.32-.16a2.025 2.025 0 0 1-1.12-1.811v-4.697c0-.767.434-1.468 1.12-1.811l.32-.16"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M2.44 42.76v-7.2l5.957-.541a1.8 1.8 0 0 1 1.963 1.793v4.697a1.8 1.8 0 0 1-1.963 1.793l-5.957-.541Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m3.88 43.48-.32-.16a2.025 2.025 0 0 1-1.12-1.811v-4.697c0-.767.433-1.468 1.12-1.811l.32-.16"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M57.16 42.76v-7.2l-5.957-.541a1.8 1.8 0 0 0-1.963 1.793v4.697a1.8 1.8 0 0 0 1.963 1.793l5.957-.541Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m55.72 43.48.32-.16a2.025 2.025 0 0 0 1.12-1.811v-4.697c0-.767-.434-1.468-1.12-1.811l-.32-.16"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35.56 2.44h7.2l.541 5.956a1.8 1.8 0 0 1-1.792 1.963H36.81a1.8 1.8 0 0 1-1.793-1.963l.542-5.957Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m34.84 3.88.16-.321a2.025 2.025 0 0 1 1.811-1.12h4.697c.767 0 1.468.434 1.811 1.12l.16.32"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M35.56 57.16h7.2l.541-5.957a1.8 1.8 0 0 0-1.792-1.963H36.81a1.8 1.8 0 0 0-1.793 1.963l.542 5.957Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 1.44,
  d: "m34.84 55.72.16.32a2.025 2.025 0 0 0 1.811 1.12h4.697c.767 0 1.468-.433 1.811-1.12l.16-.32"
})));
SvgNoTableNotUserBSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoTableNotUserBSelected);
export default ForwardRef;